/**
 * @generated SignedSource<<ac3bc47b8cc9d4666b12d00f86b0f286>>
 * @relayHash 803200a52f130572caf872b4e016fb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12

import type { ConcreteRequest, Query } from 'relay-runtime';
export type usergroup_forge_ui_usersQuery$variables = {
  accountIds: ReadonlyArray<string>;
};
export type usergroup_forge_ui_usersQuery$data = {
  readonly users: ReadonlyArray<{
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  }> | null | undefined;
};
export type usergroup_forge_ui_usersQuery = {
  response: usergroup_forge_ui_usersQuery$data;
  variables: usergroup_forge_ui_usersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usergroup_forge_ui_usersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usergroup_forge_ui_usersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12",
    "metadata": {},
    "name": "usergroup_forge_ui_usersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d0105c23c646ed326ba46ee28241752a";

export default node;
